import { getItemType } from "../getItemType/index.js";

export const qualifiesForDraughtDuty = (
  product: {
    abv?: number | null;
    containerType?: string | null;
    volume?: number | null;
    unit?: string | null;
  } | null,
) => {
  if (!product) return false;
  const abv = product.abv ?? 0;
  const containerType = getItemType(product.containerType ?? null);
  const volume = product.volume ?? 0;
  const unit = product.unit ? product.unit.toLowerCase() : "";

  if (!containerType || !volume || unit === "") return false;

  return (
    (containerType === "keg" || containerType === "cask") &&
    ((volume >= 20 && unit === "l") || (volume >= 4.5 && unit === "gal")) &&
    abv <= 8.5
  );
};
